import type { FunctionComponent } from 'react'

export type IconProps = {
	name:
	| 'arrowDown'
	| 'login'
	| 'facebook'
	| 'linkedin'
	| 'x'
	| 'info'
	| 'target'
	| 'team'
	| 'webinarInfo'
	| 'signUpDownload'
	| 'signUpWebinar'
	| 'lockedArticle'
	| 'arrowCircle'
	| 'star'
	| 'phone'
	| 'mail'
	| 'whatsapp'
	strokeColor?: string
	fillColor?: string
}

export const Icon: FunctionComponent<IconProps> = ({ name, fillColor, strokeColor }) => {
	switch (name) {
		case 'arrowDown':
			return (
				<svg width="10" height="7" viewBox="0 0 10 7" fill="none" className="icon" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.999547 1.24264L5.24219 5.48528L9.48483 1.24264" stroke={strokeColor ?? '#000'} />
				</svg>
			)
		case 'login':
			return (
				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" className="icon" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M5 5C4.3125 5 3.72396 4.75521 3.23438 4.26562C2.74479 3.77604 2.5 3.1875 2.5 2.5C2.5 1.8125 2.74479 1.22396 3.23438 0.734375C3.72396 0.244792 4.3125 0 5 0C5.6875 0 6.27604 0.244792 6.76562 0.734375C7.25521 1.22396 7.5 1.8125 7.5 2.5C7.5 3.1875 7.25521 3.77604 6.76562 4.26562C6.27604 4.75521 5.6875 5 5 5ZM0 10V8.25C0 7.89583 0.0911458 7.57031 0.273438 7.27344C0.455729 6.97656 0.697917 6.75 1 6.59375C1.64583 6.27083 2.30208 6.02865 2.96875 5.86719C3.63542 5.70573 4.3125 5.625 5 5.625C5.6875 5.625 6.36458 5.70573 7.03125 5.86719C7.69792 6.02865 8.35417 6.27083 9 6.59375C9.30208 6.75 9.54427 6.97656 9.72656 7.27344C9.90885 7.57031 10 7.89583 10 8.25V10H0Z"
						fill="#4B865C"
					/>
				</svg>
			)
		case 'facebook':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M22.6752 2.71477e-08H1.32363C0.592529 0.000439482 -0.000146457 0.593408 2.71477e-08 1.3248V22.6764C0.000439482 23.4075 0.593408 24.0001 1.3248 24H12.8203V14.7188H9.70312V11.0859H12.8203V8.41245C12.8203 5.31211 14.713 3.62461 17.4787 3.62461C18.8033 3.62461 19.9417 3.72334 20.2734 3.76743V7.00781H18.3664C16.8617 7.00781 16.5703 7.7228 16.5703 8.77222V11.0859H20.168L19.6992 14.7188H16.5703V24H22.6752C23.4067 24.0001 23.9999 23.4073 24 22.6758C24 22.6756 24 22.6755 24 22.6752V1.32363C23.9997 0.592529 23.4066 -0.000146457 22.6752 2.71477e-08Z"
						fill="#F7F1EB"
					/>
				</svg>
			)
		case 'star':
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
					<path
						d="M4.34844 15.412C3.96823 15.6333 3.50813 15.2911 3.61069 14.8633L4.68414 10.3855C4.72839 10.2009 4.66431 10.0072 4.51874 9.88542L0.932706 6.88552C0.59008 6.5989 0.766646 6.04105 1.21179 6.00376L5.98686 5.60381C6.16972 5.58849 6.3295 5.47424 6.40312 5.30616L8.26928 1.04562C8.44413 0.646428 9.01042 0.646429 9.18527 1.04562L11.0514 5.30616C11.125 5.47424 11.2848 5.58849 11.4677 5.60381L16.2428 6.00376C16.6879 6.04105 16.8645 6.5989 16.5218 6.88552L12.9358 9.88542C12.7902 10.0072 12.7262 10.2009 12.7704 10.3855L13.8439 14.8633C13.9464 15.2911 13.4863 15.6333 13.1061 15.412L8.9788 13.0096C8.82333 12.9191 8.63122 12.9191 8.47574 13.0096L4.34844 15.412Z"
						fill="#E3CD2F"
					/>
				</svg>
			)
		case 'linkedin':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M21.829 0H2.17099C0.972 0 0 0.972 0 2.17099V21.8289C0 23.028 0.972 24 2.17099 24H21.8289C23.028 24 24 23.028 24 21.8289V2.17099C24 0.972 23.028 0 21.829 0ZM7.42662 20.7232C7.42662 21.0721 7.14377 21.355 6.79483 21.355H4.10544C3.7565 21.355 3.47365 21.0721 3.47365 20.7232V9.4494C3.47365 9.10046 3.7565 8.81761 4.10544 8.81761H6.79483C7.14377 8.81761 7.42662 9.10046 7.42662 9.4494V20.7232ZM5.45014 7.75489C4.0391 7.75489 2.8952 6.61099 2.8952 5.19996C2.8952 3.78892 4.0391 2.64503 5.45014 2.64503C6.86117 2.64503 8.00507 3.78892 8.00507 5.19996C8.00507 6.61099 6.86124 7.75489 5.45014 7.75489ZM21.4813 20.7741C21.4813 21.0949 21.2212 21.355 20.9004 21.355H18.0145C17.6937 21.355 17.4335 21.0949 17.4335 20.7741V15.486C17.4335 14.6972 17.6649 12.0292 15.372 12.0292C13.5934 12.0292 13.2327 13.8553 13.1602 14.6749V20.7741C13.1602 21.0949 12.9002 21.355 12.5793 21.355H9.78817C9.46737 21.355 9.20727 21.0949 9.20727 20.7741V9.39851C9.20727 9.07772 9.46737 8.81761 9.78817 8.81761H12.5793C12.9001 8.81761 13.1602 9.07772 13.1602 9.39851V10.3821C13.8197 9.39236 14.7998 8.62844 16.8866 8.62844C21.5077 8.62844 21.4813 12.9457 21.4813 15.3178V20.7741Z"
						fill={fillColor ?? '#F7F1EB'}
					/>
				</svg>
			)
		case 'arrowCircle':
			return (
				<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="16" cy="16" r="16" fill="#4B865C" />
					<path d="M14.2426 20.2426L18.4853 16L14.2426 11.7574" stroke="white" strokeWidth="1.8" />
				</svg>
			)
		case 'x':
			return (
				<svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M20.8544 0H24.9155L16.0441 10.1652L26.4817 24H18.3102L11.9054 15.611L4.58512 24H0.520177L10.0082 13.1236L0 0.00189153H8.37957L14.1602 7.66835L20.8544 0ZM19.4262 21.5637H21.6772L7.15006 2.30958H4.73644L19.4262 21.5637Z"
						fill="white"
					/>
				</svg>
			)
		case 'info':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M10.8 18H13.2V10.8H10.8V18ZM12 8.4C12.34 8.4 12.625 8.285 12.855 8.055C13.085 7.825 13.2 7.54 13.2 7.2C13.2 6.86 13.085 6.575 12.855 6.345C12.625 6.115 12.34 6 12 6C11.66 6 11.375 6.115 11.145 6.345C10.915 6.575 10.8 6.86 10.8 7.2C10.8 7.54 10.915 7.825 11.145 8.055C11.375 8.285 11.66 8.4 12 8.4ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24Z"
						fill="#4B865C"
					/>
				</svg>
			)
		case 'target':
			return (
				<svg width="64" height="70" viewBox="0 0 64 70" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_2070_131)">
						<path
							d="M60.11 39.87C60.11 56.47 46.65 69.93 30.05 69.93C21.75 69.93 14.25 66.56 8.81 61.12C3.37 55.69 0.01 48.17 0 39.87C0 23.28 13.46 9.82 30.05 9.82C46.64 9.82 60.11 23.28 60.11 39.87Z"
							fill="url(#paint0_linear_2070_131)"
						/>
						<path d="M28.1801 39.95V0H49.3301L50.2701 4.7H63.4301V28.2H46.9801L46.0401 23.5H32.8801V39.95H28.1801Z" fill="#4B865C" />
					</g>
					<defs>
						<linearGradient id="paint0_linear_2070_131" x1="15.03" y1="65.91" x2="45.09" y2="13.85" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" stopOpacity="0.7" />
							<stop offset="0.44" stopColor="#6FAE81" stopOpacity="0.35" />
							<stop offset="0.81" stopColor="#6FAE81" stopOpacity="0.1" />
							<stop offset="1" stopColor="#6FAE81" stopOpacity="0" />
						</linearGradient>
						<clipPath id="clip0_2070_131">
							<rect width="63.43" height="69.94" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)
		case 'team':
			return (
				<svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_3071_5994)">
						<path
							d="M23.9489 5.34422C23.9489 8.29751 21.5543 10.6921 18.6011 10.6921C17.1244 10.6921 15.7893 10.0934 14.8242 9.12472C13.8555 8.15601 13.2605 6.82086 13.2568 5.34422C13.2568 2.39456 15.6514 0 18.6011 0C21.5507 0 23.9489 2.39456 23.9489 5.34422Z"
							fill="url(#paint0_linear_3071_5994)"
						/>
						<path
							d="M18.6054 11.8059C22.4802 11.8059 25.6258 14.9515 25.6258 18.8263V24H11.585V18.8263C11.585 14.9515 14.7305 11.8059 18.6054 11.8059Z"
							fill="url(#paint1_linear_3071_5994)"
						/>
						<path
							d="M12.3678 5.34422C12.3678 8.29751 9.97329 10.6921 7.02 10.6921C5.54336 10.6921 4.20821 10.0934 3.24313 9.12472C2.27442 8.15601 1.67941 6.82086 1.67579 5.34422C1.67216 2.39456 4.06672 0 7.02 0C9.97329 0 12.3678 2.39456 12.3678 5.34422Z"
							fill="#4B865C"
						/>
						<path
							d="M7.02041 11.8059C10.8952 11.8059 14.0408 14.9515 14.0408 18.8263V24H0V18.8263C0 14.9515 3.14558 11.8059 7.02041 11.8059Z"
							fill="#4B865C"
						/>
					</g>
					<defs>
						<linearGradient id="paint0_linear_3071_5994" x1="15.9308" y1="9.97732" x2="21.2786" y2="0.714739" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" stopOpacity="0.7" />
							<stop offset="0.44" stopColor="#6FAE81" stopOpacity="0.35" />
							<stop offset="0.81" stopColor="#6FAE81" stopOpacity="0.1" />
							<stop offset="1" stopColor="#6FAE81" stopOpacity="0" />
						</linearGradient>
						<linearGradient id="paint1_linear_3071_5994" x1="15.3219" y1="26.1587" x2="22.8285" y2="13.1592" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" stopOpacity="0.7" />
							<stop offset="0.44" stopColor="#6FAE81" stopOpacity="0.35" />
							<stop offset="0.81" stopColor="#6FAE81" stopOpacity="0.1" />
							<stop offset="1" stopColor="#6FAE81" stopOpacity="0" />
						</linearGradient>
						<clipPath id="clip0_3071_5994">
							<rect width="25.6254" height="24" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)
		case 'webinarInfo':
			return (
				<svg width="64" height="75" viewBox="0 0 64 75" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_2204_13540)">
						<path
							d="M62.84 49.95C62.17 50.81 61.28 51.24 60.17 51.24H53.48V61.27C53.48 63.11 52.83 64.68 51.52 65.99C50.21 67.3 48.63 67.96 46.8 67.96H40.11V74.64H10.02V60.27C6.85 57.37 4.38 53.99 2.63 50.11C0.87 46.24 0 42.16 0 37.87C0 29.51 2.92 22.41 8.77 16.56C14.62 10.71 21.72 7.79004 30.08 7.79004C37.05 7.79004 43.22 9.83004 48.59 13.93C53.97 18.02 57.46 23.36 59.08 29.93L63.43 47.06C63.7 48.12 63.51 49.08 62.84 49.95Z"
							fill="url(#paint0_linear_2204_13540)"
						/>
						<path d="M34.9304 35.24H26.6504V43.52H34.9304V35.24Z" fill="#4B865C" />
						<path d="M34.9304 0H26.6504V30.47H34.9304V0Z" fill="#4B865C" />
					</g>
					<defs>
						<linearGradient id="paint0_linear_2204_13540" x1="10.98" y1="75.2" x2="47.04" y2="12.74" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" />
							<stop offset="0.48" stopColor="#B4D5BE" />
							<stop offset="0.82" stopColor="#E1EEE5" />
							<stop offset="1" stopColor="#F2F8F4" />
						</linearGradient>
						<clipPath id="clip0_2204_13540">
							<rect width="63.55" height="74.64" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)
		case 'signUpDownload':
			return (
				<svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_2234_8127)">
						<path
							d="M35.7192 13.3972V40.1849C35.7192 41.4096 35.2929 42.4652 34.4268 43.3313C33.5337 44.2041 32.4849 44.6507 31.2535 44.6507H4.46575C3.24105 44.6507 2.18551 44.2041 1.31942 43.3313C0.446575 42.4584 0 41.4096 0 40.1849V4.46575C0 3.24105 0.446575 2.18551 1.31942 1.31942C2.18551 0.426276 3.23428 0 4.46575 0H22.3287L35.726 13.3972H35.7192Z"
							fill="url(#paint0_linear_2234_8127)"
						/>
						<path d="M17.7342 48L8.51172 38.7775L11.861 35.4282L17.7342 41.3014L23.6073 35.4282L26.9566 38.7775L17.7342 48Z" fill="#4B865C" />
						<path d="M20.1016 21.2327H15.3652V44.6508H20.1016V21.2327Z" fill="#4B865C" />
					</g>
					<defs>
						<linearGradient id="paint0_linear_2234_8127" x1="4.55371" y1="45.3882" x2="28.6484" y2="3.65379" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" stopOpacity="0.7" />
							<stop offset="0.44" stopColor="#6FAE81" stopOpacity="0.35" />
							<stop offset="0.81" stopColor="#6FAE81" stopOpacity="0.1" />
							<stop offset="1" stopColor="#6FAE81" stopOpacity="0" />
						</linearGradient>
						<clipPath id="clip0_2234_8127">
							<rect width="35.7192" height="48" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)
		case 'signUpWebinar':
			return (
				<svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_2234_8049)">
						<path
							d="M42.572 26.7071C42.572 38.4632 33.0421 48 21.2791 48C15.3977 48 10.0865 45.6158 6.23189 41.7612C2.3842 37.9066 0.00687088 32.5886 0 26.7071C0 14.9579 9.52992 5.42798 21.286 5.42798C33.0421 5.42798 42.5789 14.9579 42.5789 26.714L42.572 26.7071Z"
							fill="url(#paint0_linear_2234_8049)"
						/>
						<path
							d="M30.8979 37.7899C28.3144 37.7899 25.8753 37.2952 23.5735 36.2989C21.2718 35.3026 19.2655 33.9559 17.5478 32.2382C15.83 30.5205 14.4765 28.5142 13.4871 26.2125C12.4977 23.9107 11.9961 21.4715 11.9961 18.8881C11.9961 16.3046 12.4908 13.8243 13.4871 11.5431C14.4834 9.26199 15.83 7.26256 17.5478 5.54484C19.2655 3.82712 21.2718 2.47355 23.5735 1.48415C25.8753 0.494739 28.3144 -0.00683594 30.8979 -0.00683594C33.4814 -0.00683594 35.9617 0.487868 38.2429 1.48415C40.524 2.48042 42.5234 3.82712 44.2412 5.54484C45.9589 7.26256 47.3124 9.26199 48.3019 11.5431C49.2913 13.8243 49.7928 16.2772 49.7928 18.8881C49.7928 21.499 49.2981 23.9107 48.3019 26.2125C47.3056 28.5142 45.9589 30.5205 44.2412 32.2382C42.5234 33.9559 40.524 35.3095 38.2429 36.2989C35.9617 37.2883 33.5088 37.7899 30.8979 37.7899ZM30.8979 33.9147C31.7155 32.781 32.4232 31.5992 33.021 30.3693C33.6188 29.1395 34.1066 27.834 34.4845 26.4461H27.3044C27.6823 27.834 28.1702 29.1395 28.7679 30.3693C29.3657 31.5992 30.0734 32.781 30.891 33.9147H30.8979ZM25.9852 33.1589C25.4149 32.1214 24.9202 31.0427 24.4942 29.9227C24.0682 28.8028 23.7178 27.6485 23.4292 26.4529H17.857C18.7708 28.0264 19.9114 29.4005 21.2787 30.5617C22.646 31.7298 24.2125 32.5955 25.9783 33.1589H25.9852ZM35.8106 33.1589C37.5764 32.5886 39.143 31.7229 40.5103 30.5617C41.8776 29.3937 43.025 28.0264 43.932 26.4529H38.3597C38.078 27.6485 37.7207 28.8097 37.2947 29.9227C36.8687 31.0427 36.374 32.1214 35.8037 33.1589H35.8106ZM16.256 22.674H22.6803C22.5841 22.0418 22.5154 21.4235 22.4673 20.8051C22.4192 20.1867 22.3986 19.5546 22.3986 18.895C22.3986 18.2354 22.4192 17.5964 22.4673 16.9849C22.5154 16.3734 22.5841 15.7481 22.6803 15.116H16.256C16.098 15.7481 15.9812 16.3665 15.8988 16.9849C15.8163 17.6032 15.782 18.2354 15.782 18.895C15.782 19.5546 15.8232 20.1936 15.8988 20.8051C15.9743 21.4166 16.098 22.0418 16.256 22.674ZM26.4593 22.674H35.3434C35.4396 22.0418 35.5083 21.4235 35.5564 20.8051C35.6045 20.1867 35.6251 19.5546 35.6251 18.895C35.6251 18.2354 35.6045 17.5964 35.5564 16.9849C35.5083 16.3734 35.4396 15.7481 35.3434 15.116H26.4593C26.3631 15.7481 26.2944 16.3665 26.2463 16.9849C26.1982 17.6032 26.1776 18.2354 26.1776 18.895C26.1776 19.5546 26.1982 20.1936 26.2463 20.8051C26.2944 21.4166 26.3631 22.0418 26.4593 22.674ZM39.1155 22.674H45.5398C45.6978 22.0418 45.8146 21.4235 45.897 20.8051C45.9795 20.1867 46.0138 19.5546 46.0138 18.895C46.0138 18.2354 45.9726 17.5964 45.897 16.9849C45.8215 16.3734 45.6978 15.7481 45.5398 15.116H39.1155C39.2117 15.7481 39.2804 16.3665 39.3285 16.9849C39.3766 17.6032 39.3972 18.2354 39.3972 18.895C39.3972 19.5546 39.3766 20.1936 39.3285 20.8051C39.2804 21.4166 39.2117 22.0418 39.1155 22.674ZM38.3597 11.337H43.932C43.0181 9.76356 41.8776 8.38939 40.5103 7.22821C39.143 6.06703 37.5764 5.19442 35.8106 4.63101C36.3809 5.66851 36.8756 6.74724 37.3016 7.8672C37.7276 8.98715 38.078 10.1415 38.3666 11.337H38.3597ZM27.3044 11.337H34.4845C34.1066 9.94908 33.6188 8.64361 33.021 7.41372C32.4232 6.18383 31.7155 5.00204 30.8979 3.86834C30.0803 5.00204 29.3726 6.18383 28.7748 7.41372C28.177 8.64361 27.6892 9.94908 27.3113 11.337H27.3044ZM17.857 11.337H23.4292C23.711 10.1415 24.0682 8.98028 24.4942 7.8672C24.9202 6.75411 25.4149 5.66851 25.9852 4.63101C24.2194 5.20129 22.6528 6.06703 21.2855 7.22821C19.9182 8.38939 18.7708 9.76356 17.8638 11.337H17.857Z"
							fill="#4B865C"
						/>
					</g>
					<defs>
						<linearGradient id="paint0_linear_2234_8049" x1="10.643" y1="45.1486" x2="31.929" y2="8.27939" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" stopOpacity="0.7" />
							<stop offset="0.44" stopColor="#6FAE81" stopOpacity="0.35" />
							<stop offset="0.81" stopColor="#6FAE81" stopOpacity="0.1" />
							<stop offset="1" stopColor="#6FAE81" stopOpacity="0" />
						</linearGradient>
						<clipPath id="clip0_2234_8049">
							<rect width="49.7933" height="48" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)
		case 'lockedArticle':
			return (
				<svg width="66" height="80" viewBox="0 0 66 80" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_2182_10879)">
						<path
							d="M59.1071 22.1693V66.4969C59.1071 68.5234 58.4017 70.2701 56.9685 71.7033C55.4906 73.1477 53.7551 73.8866 51.7173 73.8866H7.38978C5.36319 73.8866 3.61651 73.1477 2.18335 71.7033C0.738978 70.2589 0 68.5234 0 66.4969V7.38978C0 5.36319 0.738978 3.61652 2.18335 2.18335C3.61651 0.705388 5.35199 0 7.38978 0H36.9489L59.1183 22.1693H59.1071Z"
							fill="url(#paint0_linear_2182_10879)"
						/>
						<path
							d="M34.296 80C33.0531 80 31.9895 79.5633 31.1161 78.6788C30.2428 77.7943 29.7949 76.7306 29.7949 75.499V52.9489C29.7949 51.7061 30.2316 50.6424 31.1161 49.7691C32.0007 48.8957 33.0643 48.4479 34.296 48.4479H36.5465V43.9356C36.5465 40.8118 37.6438 38.1582 39.8495 35.9636C42.0552 33.7691 44.7088 32.6606 47.8215 32.6606C50.9342 32.6606 53.599 33.7579 55.7935 35.9636C57.9881 38.1694 59.0965 40.823 59.0965 43.9356V48.4479H61.3471C62.5899 48.4479 63.6536 48.8845 64.5269 49.7691C65.4002 50.6536 65.8481 51.7173 65.8481 52.9489V75.499C65.8481 76.7418 65.4114 77.8055 64.5269 78.6788C63.6424 79.5521 62.5787 80 61.3471 80H34.2848H34.296ZM47.8327 68.725C49.0755 68.725 50.1392 68.2883 51.0126 67.4038C51.8859 66.5193 52.3338 65.4556 52.3338 64.2239C52.3338 62.9923 51.8971 61.9174 51.0126 61.0441C50.128 60.1708 49.0643 59.7229 47.8327 59.7229C46.6011 59.7229 45.5262 60.1596 44.6529 61.0441C43.7795 61.9286 43.3317 62.9923 43.3317 64.2239C43.3317 65.4556 43.7683 66.5305 44.6529 67.4038C45.5374 68.2771 46.6011 68.725 47.8327 68.725ZM41.0587 48.4255H54.5843V43.9132C54.5843 42.0322 53.9237 40.4423 52.6137 39.1211C51.3037 37.7999 49.7025 37.1505 47.8215 37.1505C45.9405 37.1505 44.3506 37.8111 43.0294 39.1211C41.7081 40.4311 41.0587 42.0322 41.0587 43.9132V48.4255Z"
							fill="#4B865C"
						/>
					</g>
					<defs>
						<linearGradient id="paint0_linear_2182_10879" x1="7.53534" y1="75.1071" x2="47.4066" y2="6.04619" gradientUnits="userSpaceOnUse">
							<stop stopColor="#6FAE81" />
							<stop offset="0.48" stopColor="#B4D5BE" />
							<stop offset="0.82" stopColor="#E1EEE5" />
							<stop offset="1" stopColor="#F2F8F4" />
						</linearGradient>
						<clipPath id="clip0_2182_10879">
							<rect width="65.8698" height="80" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)
		case 'phone':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M19.95 21C17.8 21 15.7043 20.5207 13.663 19.562C11.621 18.604 9.81267 17.3373 8.238 15.762C6.66267 14.1873 5.396 12.379 4.438 10.337C3.47933 8.29567 3 6.2 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07933 8.725 3.238C8.90833 3.396 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.704 12.1127 8.162 12.688C8.62067 13.2627 9.12433 13.8167 9.673 14.35C10.1897 14.8667 10.7377 15.3543 11.317 15.813C11.896 16.271 12.5 16.6833 13.13 17.05L15.45 14.75C15.6 14.6 15.796 14.4877 16.038 14.413C16.2793 14.3377 16.5167 14.3167 16.75 14.35L20.2 15.05C20.4333 15.1 20.625 15.2167 20.775 15.4C20.925 15.5833 21 15.7833 21 16V20.05C21 20.35 20.9 20.6 20.7 20.8C20.5 21 20.25 21.1 19.95 21.1V21Z"
						fill={fillColor ?? '#1C3C27'}
					/>
				</svg>
			)
		case 'mail':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M4 20C3.45 20 2.979 19.8043 2.587 19.413C2.19567 19.021 2 18.55 2 18V6C2 5.45 2.19567 4.979 2.587 4.587C2.979 4.19567 3.45 4 4 4H20C20.55 4 21.021 4.19567 21.413 4.587C21.8043 4.979 22 5.45 22 6V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4ZM12 13L4 8V18H20V8L12 13ZM12 11L20 6H4L12 11ZM4 8V6V18V8Z"
						fill={fillColor ?? '#1C3C27'}
					/>
				</svg>
			)
		case 'whatsapp':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
						fill={fillColor ?? '#1C3C27'}
					/>
				</svg>
			)
	}
}
